import { useState, FormEvent } from 'react';

const FormularioContacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    marca: '',
    modelo: '',
    anio: '',
    estado: '',
    kilometros: '',
    ubicacion: '',
    mensaje: '',
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === 'mensaje' && value.length > 500) return;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!formData.nombre || !formData.telefono || !formData.marca || !formData.estado) return;

    const mensaje = `Hola, quiero vender mi coche. He rellenado el formulario en vuestra web.

👤 *Datos de contacto:*
• Nombre: ${formData.nombre}${formData.telefono ? `\n• Teléfono: ${formData.telefono}` : ''}${formData.email ? `\n• Email: ${formData.email}` : ''}

🚗 *Datos del vehículo:*
• Marca: ${formData.marca}${formData.modelo ? `\n• Modelo: ${formData.modelo}` : ''}${formData.anio ? `\n• Año: ${formData.anio}` : ''}${formData.kilometros ? `\n• Kilómetros: ${formData.kilometros}` : ''}
• Estado: ${formData.estado}${formData.ubicacion ? `\n• Ubicación: ${formData.ubicacion}` : ''}${formData.mensaje ? `\n\n💬 *Información adicional:*\n${formData.mensaje}` : ''}

¿Podrían darme una valoración gratuita? Gracias.`;

    const url = `https://wa.me/34932932913?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');

    setSubmitStatus('success');
    setFormData({
      nombre: '',
      email: '',
      telefono: '',
      marca: '',
      modelo: '',
      anio: '',
      estado: '',
      kilometros: '',
      ubicacion: '',
      mensaje: '',
    });
  };

  const estadoOptions = [
    'Siniestro total',
    'Averiado (no arranca)',
    'Averiado (arranca pero con fallos)',
    'Para chatarra',
    'Abandonado / sin ITV',
    'Funciona pero quiero venderlo',
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-white" id="formulario-vender-coche">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Columna izquierda - Info */}
          <div>
            <span className="inline-block bg-emerald-100 text-emerald-700 text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full mb-6">
              Solicita tu Valoración
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Pide tu <strong>Valoración Gratuita</strong> en Gavá
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              Rellena el formulario con los datos de tu vehículo y te enviaremos una <strong>oferta sin compromiso en menos de 2 horas</strong>. También puedes contactarnos directamente por teléfono o WhatsApp.
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-timer-flash-fill text-emerald-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Respuesta Rápida</h3>
                  <p className="text-gray-600 text-sm">Te respondemos en menos de 2 horas con una oferta personalizada para tu vehículo en Gavá.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-fill text-emerald-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Sin Compromiso</h3>
                  <p className="text-gray-600 text-sm">La valoración es 100% gratuita. Si no te convence la oferta, no tienes ninguna obligación.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-lock-fill text-emerald-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Datos Seguros</h3>
                  <p className="text-gray-600 text-sm">Tu información personal está protegida y solo se usa para la valoración de tu vehículo.</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="font-bold text-gray-900 mb-4">¿Prefieres Contacto Directo?</h3>
              <div className="space-y-4">
                <a
                  href="tel:+34932932913"
                  className="flex items-center space-x-3 text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                    <i className="ri-phone-fill text-white"></i>
                  </div>
                  <div>
                    <p className="font-bold text-sm">Llámanos</p>
                    <p className="text-sm text-gray-500">932 932 913</p>
                  </div>
                </a>
                <a
                  href="https://wa.me/34932932913?text=Hola,%20quiero%20vender%20mi%20coche%20en%20Gavá"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center space-x-3 text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                    <i className="ri-whatsapp-fill text-white"></i>
                  </div>
                  <div>
                    <p className="font-bold text-sm">WhatsApp</p>
                    <p className="text-sm text-gray-500">Respuesta inmediata</p>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Columna derecha - Formulario */}
          <div className="bg-gray-50 rounded-3xl p-8 md:p-10 shadow-lg border border-gray-100">
            <div className="flex items-center space-x-3 mb-8">
              <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                <i className="ri-file-edit-fill text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">Formulario de Valoración</h3>
            </div>

            {submitStatus === 'success' ? (
              <div className="text-center py-12">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-whatsapp-fill text-emerald-600 text-4xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-3">¡Enviado por WhatsApp!</h4>
                <p className="text-gray-600 mb-2">Se ha abierto WhatsApp con los datos de tu vehículo.</p>
                <p className="text-gray-600 mb-8">Te responderemos lo antes posible con tu <strong>valoración gratuita</strong>.</p>
                <button
                  onClick={() => setSubmitStatus('idle')}
                  className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Enviar Otra Solicitud
                </button>
              </div>
            ) : (
              <form
                id="form-vender-coche"
                onSubmit={handleSubmit}
                className="space-y-5"
              >
                {/* Datos personales */}
                <div>
                  <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Tus Datos</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1.5">
                        Nombre Completo <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                        placeholder="Tu nombre"
                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                      />
                    </div>
                    <div>
                      <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-1.5">
                        Teléfono <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleChange}
                        required
                        placeholder="Ej: 612 345 678"
                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="tu@email.com"
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                    />
                  </div>
                </div>

                {/* Datos del vehículo */}
                <div>
                  <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3 mt-2">Datos del Vehículo</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="marca" className="block text-sm font-medium text-gray-700 mb-1.5">
                        Marca <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="marca"
                        name="marca"
                        value={formData.marca}
                        onChange={handleChange}
                        required
                        placeholder="Ej: Seat, Renault..."
                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                      />
                    </div>
                    <div>
                      <label htmlFor="modelo" className="block text-sm font-medium text-gray-700 mb-1.5">
                        Modelo
                      </label>
                      <input
                        type="text"
                        id="modelo"
                        name="modelo"
                        value={formData.modelo}
                        onChange={handleChange}
                        placeholder="Ej: Ibiza, Clio..."
                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                      />
                    </div>
                    <div>
                      <label htmlFor="anio" className="block text-sm font-medium text-gray-700 mb-1.5">
                        Año
                      </label>
                      <input
                        type="text"
                        id="anio"
                        name="anio"
                        value={formData.anio}
                        onChange={handleChange}
                        placeholder="Ej: 2015"
                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                      />
                    </div>
                    <div>
                      <label htmlFor="kilometros" className="block text-sm font-medium text-gray-700 mb-1.5">
                        Kilómetros
                      </label>
                      <input
                        type="text"
                        id="kilometros"
                        name="kilometros"
                        value={formData.kilometros}
                        onChange={handleChange}
                        placeholder="Ej: 120.000 km"
                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <label htmlFor="estado" className="block text-sm font-medium text-gray-700 mb-1.5">
                      Estado del Vehículo <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="estado"
                      name="estado"
                      value={formData.estado}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all cursor-pointer"
                    >
                      <option value="">Selecciona el estado...</option>
                      {estadoOptions.map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mt-4">
                    <label htmlFor="ubicacion" className="block text-sm font-medium text-gray-700 mb-1.5">
                      Ubicación del Vehículo
                    </label>
                    <input
                      type="text"
                      id="ubicacion"
                      name="ubicacion"
                      value={formData.ubicacion}
                      onChange={handleChange}
                      placeholder="Ej: Gavá, Castelldefels..."
                      className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all"
                    />
                  </div>
                </div>

                {/* Mensaje */}
                <div>
                  <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700 mb-1.5">
                    Información Adicional
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    rows={4}
                    maxLength={500}
                    placeholder="Describe los daños, averías o cualquier detalle relevante sobre tu coche..."
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all resize-none"
                  ></textarea>
                  <p className="text-xs text-gray-400 mt-1 text-right">{formData.mensaje.length}/500</p>
                </div>

                <button
                  type="submit"
                  className="w-full bg-green-500 hover:bg-green-600 text-white py-4 rounded-lg font-bold text-lg transition-all hover:scale-[1.02] shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center justify-center space-x-3"
                >
                  <i className="ri-whatsapp-line text-2xl"></i>
                  <span>Enviar por WhatsApp</span>
                </button>

                <p className="text-xs text-gray-400 text-center">
                  Al pulsar se abrirá WhatsApp con los datos de tu vehículo para solicitar valoración.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormularioContacto;
